import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-edit-scan-machine',
  templateUrl: './add-edit-scan-machine.component.html',
  styleUrls: ['./add-edit-scan-machine.component.css']
})
export class AddEditScanMachineComponent implements OnInit {

  machineForm: FormGroup; submitted = false; loading: boolean = false; machine_id: any = '';
  constructor(public router: Router, private formBuilder: FormBuilder, public miscapi: MiscService, private sharedapi: SharedService, public dialogRef: MatDialogRef<AddEditScanMachineComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog) {

    this.machineForm = this.formBuilder.group({
      'machine_name': [null, Validators.required]
    });

    if (data) {
      this.machine_id = data;
      this.patchMachineData(this.machine_id);
    }
  }

  get f() { return this.machineForm.controls; }

  async createMachine() {
    this.submitted = true;
    this.loading = true;
    if (this.machineForm.invalid) {
      this.loading = false;
      return;
    }
    this.machineForm.value.id = parseInt(this.machine_id);
    await this.miscapi.addEditMachine(this.machineForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigate(['/scan-machine-list'])
          .then(() => {
            window.location.reload();
          });
        this.CloseModal();
        this.machineForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  ngOnInit(): void {
  }

  async patchMachineData(machine_id) {
    await this.miscapi.getMachineEditData(this.machine_id).subscribe((response: any) => {
      if (response.status) {
        this.machineForm.patchValue({
          'machine_name': response.data.name
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }
}
